import { Controller } from '@hotwired/stimulus'

export default class extends Controller {

  static values = {
    url: String
  }

  connect() {
    if (this.hasUrlValue) {
      location.href = this.urlValue
    } else {
      console.error('No URL value provided to turbo--breakout-redirect.')
    }
  }
}